import { ColumnDefinition } from './column-definition';

/**
 * Représente la définition d'une colonne contenant une étape de workflow.
 */
export class WorkflowStepColumnDefinition extends ColumnDefinition {
    /**
     * Retourne une instance de WorkflowStepColumnDefinition à partir d'une instance de ColumnDefinition.
     * @param other : Instance de ColumnDefinition.
     * @returns : Instance de WorkflowStepColumnDefinition.
     */
    public static override from(other: ColumnDefinition) {
        if (!!other) {
            const instance = new WorkflowStepColumnDefinition();

            instance.propertyCode = other.propertyCode;
            instance.header = other.header;
            instance.type = other.type;
            instance.size = other.size;
            instance.isStickyColumn = other.isStickyColumn;
            instance.values = other.values;

            return instance;
        } else {
            return null;
        }
    }
}
